import { Box, Skeleton, Stack } from "@mui/material";

const SectionCard: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Box
    sx={{
      border: (theme) => `1px solid ${theme.palette.divider}`,
      borderRadius: 2,
      p: 3,
    }}
  >
    {children}
  </Box>
);

const FieldSkeleton: React.FC = () => (
  <Stack spacing={1}>
    <Skeleton
      variant="text"
      animation="wave"
      sx={{ fontSize: "14px", width: 120 }}
    />
    <Skeleton
      variant="rounded"
      animation="wave"
      height={44}
      sx={{ borderRadius: 1 }}
    />
  </Stack>
);

export const MyProfileSkeleton: React.FC = () => {
  return (
    <Box sx={{ maxWidth: 1440, margin: "0 auto" }}>
      <Stack spacing={3}>
        {/* Personal Info Section */}
        <SectionCard>
          <Skeleton
            variant="text"
            animation="wave"
            sx={{ fontSize: "20px", width: 200, mb: 3 }}
          />
          <Stack direction={{ xs: "column", sm: "row" }} spacing={3} alignItems="center">
            <Skeleton
              variant="circular"
              animation="wave"
              width={120}
              height={120}
            />
            <Stack spacing={1} sx={{ flexGrow: 1 }}>
              <Skeleton
                variant="text"
                animation="wave"
                sx={{ fontSize: "24px", width: 280 }}
              />
              <Skeleton
                variant="text"
                animation="wave"
                sx={{ fontSize: "16px", width: 200 }}
              />
              <Skeleton
                variant="text"
                animation="wave"
                sx={{ fontSize: "14px", width: 140 }}
              />
            </Stack>
          </Stack>

          <Box
            sx={{
              mt: 4,
              display: "grid",
              gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
              gap: 3,
            }}
          >
            <FieldSkeleton />
            <FieldSkeleton />
            <FieldSkeleton />
          </Box>
        </SectionCard>

        {/* My Details Section */}
        <SectionCard>
          <Skeleton
            variant="text"
            animation="wave"
            sx={{ fontSize: "20px", width: 160, mb: 3 }}
          />
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
              gap: 3,
            }}
          >
            {Array.from({ length: 6 }).map((_, i) => (
              <FieldSkeleton key={i} />
            ))}
          </Box>
        </SectionCard>

        {/* Save button */}
        <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
          <Skeleton
            variant="rounded"
            animation="wave"
            width={120}
            height={40}
          />
        </Box>
      </Stack>
    </Box>
  );
};
